import React from 'react'
import _ from 'lodash'

import PillRow from './PillRow'
import './PillRows.scss'

const PillRows = React.forwardRef(
  ({items = [], headers = {primary: [], secondary: []}, breakpoint = {}}, ref) => {
    return (
      <div ref={ref} className="c-pill-rows">
        {_.map(items, (item, i) =>
          item.groupOnly ? (
            <div key={i}></div>
          ) : (
            <PillRow key={i} data={item} headers={headers} breakpoint={breakpoint} />
          )
        )}
      </div>
    )
  }
)

export default PillRows
